import React from "react";

const ContactInfo = () => {
  return (
    <>
      <div className="contact-info">
        <h4>¡Estamos listos para ayudarte!</h4>
        <p>
          Contactanos
        </p>

        <ul>
          <li className="media">
            <i className="icon icon-map"></i>
            <span className="media-body">
              Ramón Corona 174, Col. Santa Anita, Tlaquepaque, Jalisco. C.P. 45600
            </span>
          </li>
          {/* End li */}

          <li className="media">
            <i className="icon icon-envelope"></i>
            <span className="media-body">
              <a href="mailto:ventas@activodigitalmx.com">ventas@activodigitalmx.com</a>
            </span>
          </li>
          {/* End li */}

          <li className="media">
            <i className="icon icon-phone"></i>
            <span className="media-body">
              <a href="https://wa.me/523317658536" target="_blank" rel="noreferrer">33 1765 8536</a>
            </span>
          </li>
          {/* End li */}
        </ul>
      </div>
      {/* End .contact-info */}
    </>
  );
};

export default ContactInfo;
